import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import Paragraph from './Paragraph';
import './ReadingRecord.scss';
import { generateReactKey } from '../../../../../utils/shared/commonUtils';

const ReadingRecord = ({ paragraphs, baseUrl, emptyBookMessage }) => (
    <div className="level-paragraphs active">
        {isEmpty(paragraphs) ? (
            <h4 className="text-center assessment-title mt-4 ">{emptyBookMessage}</h4>
        ) : (
            paragraphs.map((paragraph, index) => (
                <Paragraph key={generateReactKey(index)} baseUrl={baseUrl} {...paragraph} />
            ))
        )}
    </div>
);

ReadingRecord.defaultProps = {
    paragraphs: [],
    baseUrl: null,
    emptyBookMessage: null,
};

ReadingRecord.propTypes = {
    paragraphs: PropTypes.array,
    baseUrl: PropTypes.string,
    emptyBookMessage: PropTypes.string,
};

export default ReadingRecord;
